export default defineNuxtPlugin(() => {
  // Disabled: global fetch monkey-patch caused noisy stack traces for every request.
})
